import { INotaryDetailsData } from './INotaryDetailsData';

export interface ISigSyncNotaryDetailsData extends INotaryDetailsData {
  signatureSyncNotaryDetails: {
    signingsAssigned?: number;
    errorRate?: number;
    doNotUseForSignature?: boolean;
    isAttorney?: boolean;
  };
}

export const isSigSyncNotary = (notary: INotaryDetailsData): notary is ISigSyncNotaryDetailsData =>
  (notary as ISigSyncNotaryDetailsData).signatureSyncNotaryDetails !== undefined;
